import { formatEntityName } from '../../../common';
import { createSchemaStatementHandler } from '../../createSchemaStatementHandler';
export const addSchemaCommentStmtInstruction = `
#### Add comment to schema entity
- Syntax: \`add comment "<comment>" in <entity_name>;\`
- Example: \`add comment "This is a comment" in Author;\`

Important notes:
- The comment is a string that describes the entity.
- The comment is used for documentation purposes.
- The comment is not used by the database engine.
`;
export const stmtAddSchemaComment = ({ comment, entityName }) => {
    return `add comment "${comment}" in ${entityName};`;
};
export const stmtForHumanAddSchemaComment = ({ comment, entityName }) => {
    return `Add the comment "${comment}" to the database table __${entityName}__.`;
};
export const addSchemaCommentHandler = createSchemaStatementHandler({
    type: 'add comment',
    parse: line => {
        const match = /^(add|create) comment "(?<comment>.+)" in (?<entityName>\w+)/.exec(line);
        return match?.groups
            ? {
                type: 'add comment',
                comment: match.groups.comment,
                entityName: formatEntityName(match.groups.entityName),
            }
            : null;
    },
    getHumanStmt: stmtForHumanAddSchemaComment,
    apply: (stmt, builder) => {
        builder.updateSchemaExtensions(it => {
            it.comments[stmt.entityName] = it.comments[stmt.entityName] || [];
            it.comments[stmt.entityName].push({
                comment: stmt.comment,
            });
            return it;
        });
    },
});
//# sourceMappingURL=AddCommentStmt.js.map